import type { ReactNode } from 'react';

// Pronto Depo's mark, the same as on prontodepo.com.tr: a shelf with two boxes on an amber tile.
// public/favicon.svg and the app icons are the same drawing.

export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg className="logo-mark" width={size} height={size} viewBox="0 0 32 32" aria-hidden>
      <rect width="32" height="32" rx="7.5" fill="#FBBF24" />
      <g fill="#0B1220">
        <rect x="6.5" y="6" width="2.8" height="20" rx="0.9" />
        <rect x="22.7" y="6" width="2.8" height="20" rx="0.9" />
        <rect x="6.5" y="14.6" width="19" height="2.5" rx="0.9" />
        <rect x="6.5" y="23.5" width="19" height="2.5" rx="0.9" />
        <rect x="11" y="8.6" width="6" height="6" rx="1" />
        <rect x="15.4" y="17.6" width="5.6" height="5.9" rx="1" />
      </g>
    </svg>
  );
}

/** The mark with the name; `sub` is a line under it (the warehouse, the seller). */
export function Logo({ sub, size = 30 }: { sub?: ReactNode; size?: number }) {
  return (
    <div className="logo">
      <LogoMark size={size} />
      <div className="logo-text">
        <span className="logo-name">
          Pronto <span className="logo-accent">Depo</span>
        </span>
        {sub && <span className="logo-sub">{sub}</span>}
      </div>
    </div>
  );
}
